import React from 'react';

import PropTypes from 'prop-types';

import { InputField } from 'components/FormHelper/InputField';
import { InfoBox } from 'components/InfoBox/InfoBox';

import { BRANCH_TYPE } from 'global/constants';
import { evaluateCondition } from 'global/fieldValidationFunction';
import { SECOND_QUALIFICATIONS } from 'global/qualifications';

export const SecondQualification = ({
  formik,
  selectedBranch,
  firstQualificationValue,
  secondQualificationName,
  secondQualificationError,
  secondQualificationValue,
}) => {
  if (!firstQualificationValue) {
    return null;
  }

  const validationConfig = {
    branch: selectedBranch,
    ...(selectedBranch === BRANCH_TYPE.ENERGY
      ? { firstQualificationEnergy: firstQualificationValue }
      : { firstQualificationGas: firstQualificationValue }),
  };
  if (selectedBranch === BRANCH_TYPE.ENERGY) {
    validationConfig.firstQualificationEnergy = firstQualificationValue;
  } else if (selectedBranch === BRANCH_TYPE.GAS) {
    validationConfig.firstQualificationGas = firstQualificationValue;
  }

  const secondQualificationsItems = Object.keys(SECOND_QUALIFICATIONS)
    .filter((qualificationsKey) =>
      evaluateCondition(
        SECOND_QUALIFICATIONS[qualificationsKey].whenShouldFieldRender,
        validationConfig
      )
    )
    .map((qualificationsKey) => SECOND_QUALIFICATIONS[qualificationsKey]);

  if (secondQualificationsItems.length > 1) {
    return (
      <div className="popup-content__popup-field">
        <InputField
          fullWidth
          select
          items={secondQualificationsItems}
          onChange={formik.handleChange}
          label="Qualifikation wählen*"
          name={secondQualificationName}
          id={secondQualificationName}
          error={Boolean(secondQualificationError)}
          value={secondQualificationValue}
          oldValue=""
        />
      </div>
    );
  }
  if (secondQualificationsItems.length === 1) {
    return (
      <div className="popup-content__popup-field">
        <div className="input-field">
          <InfoBox>{secondQualificationsItems[0].label}</InfoBox>
        </div>
      </div>
    );
  }

  return null;
};

SecondQualification.propTypes = {
  formik: PropTypes.object.isRequired,
  selectedBranch: PropTypes.string.isRequired,
  firstQualificationValue: PropTypes.string,
  secondQualificationName: PropTypes.string.isRequired,
  secondQualificationError: PropTypes.any,
  secondQualificationValue: PropTypes.string,
};

SecondQualification.defaultProps = {
  firstQualificationValue: '',
  secondQualificationError: undefined,
  secondQualificationValue: '',
};
